import { useMutation } from '@tanstack/react-query';
import { DeleteAccount } from '../api/api';


export const useDeleteAccount = ({ onSuccessCallback, onErrorCallback }) => {

  return useMutation({
    mutationFn: async ( data ) => {
      const res = await DeleteAccount(data);
      if (res.error) throw new Error(res.error);
      return res.data;
    },
    onSuccess: (newData) => {
      if (onSuccessCallback) {
        onSuccessCallback(newData);
      }
    },
    onError: (err) => {
      if (onErrorCallback) {
        onErrorCallback(err.message || 'Failed to submit');
      }
    },
  });
};